// Expand array with new prop keys as needed
const childPropsToUse = ['width'];
const ROW = 'row';
const COLUMN = 'column';

export { childPropsToUse, ROW, COLUMN };
